import { render, staticRenderFns } from "./Checked.vue?vue&type=template&id=1990772a&"
import script from "./Checked.vue?vue&type=script&lang=ts&"
export * from "./Checked.vue?vue&type=script&lang=ts&"
import style0 from "./Checked.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports